/* Scratch Repair VIN pipeline V5 - capture VIN from the actual Touchpoint registration API */
(function(){
  'use strict';
  if (window.__SR_VIN_PIPELINE_V5__) return;
  window.__SR_VIN_PIPELINE_V5__ = true;

  var HOST = 'touchpoint1.jb-digitals.com';
  var REG_KEY = 'sr_vehicle_reg_v5';
  var VIN_KEY = 'sr_vehicle_vin_v5';

  function cleanReg(v){ return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,10); }
  function cleanVin(v){ return String(v || '').toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g,'').slice(0,25); }

  function findVin(obj, depth){
    if (!obj || typeof obj !== 'object' || depth > 10) return '';
    var keys = ['vin','VIN','Vin','vin_number','vinNumber','VINNumber','vehicleIdentificationNumber','vehicle_identification_number','chassisNumber','chassis_number','chassis'];
    for (var i=0;i<keys.length;i++) {
      if (Object.prototype.hasOwnProperty.call(obj, keys[i])) {
        var candidate = cleanVin(obj[keys[i]]);
        if (candidate.length >= 11) return candidate;
      }
    }
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj,k)) continue;
      if (obj[k] && typeof obj[k] === 'object') {
        var nested = findVin(obj[k], depth + 1);
        if (nested) return nested;
      }
    }
    return '';
  }

  function requestInfo(raw){
    try {
      var url = new URL(String(raw || ''), window.location.href);
      if (url.hostname !== HOST) return null;
      var reg = cleanReg(url.searchParams.get('reg') || url.searchParams.get('registration') || '');
      return reg ? {reg:reg} : null;
    } catch(e){ return null; }
  }

  function parseAny(text){
    if (!text) return null;
    if (typeof text === 'object') return text;
    try { return JSON.parse(text); } catch(e) { return null; }
  }

  function remember(reg, payload){
    var vin = findVin(payload, 0);
    reg = cleanReg(reg);
    if (!reg || !vin) return;
    try {
      sessionStorage.setItem(REG_KEY, reg);
      sessionStorage.setItem(VIN_KEY, vin);
    } catch(e){}
    hydrate();
  }

  function currentReg(){
    try {
      var qs = new URLSearchParams(window.location.search || '');
      var fromUrl = cleanReg(qs.get('reg') || qs.get('registration') || '');
      if (fromUrl) return fromUrl;
    } catch(e){}
    var regInput = document.querySelector('input[name="properties[Registration]"]');
    return regInput ? cleanReg(regInput.value) : '';
  }

  function storedVin(){
    try {
      var reg = currentReg();
      var savedReg = cleanReg(sessionStorage.getItem(REG_KEY) || '');
      var vin = cleanVin(sessionStorage.getItem(VIN_KEY) || '');
      return reg && reg === savedReg && vin.length >= 11 ? vin : '';
    } catch(e){ return ''; }
  }

  function inject(form, vin){
    if (!form || !vin) return;
    var input = form.querySelector('input[name="properties[_VIN]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_VIN]';
      input.setAttribute('data-sr-vin','v5');
      form.appendChild(input);
    }
    input.value = vin;
  }

  function hydrate(){
    var vin = storedVin();
    if (!vin) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"], form.srp-product-form, form.srpa-product-form');
    for (var i=0;i<forms.length;i++) inject(forms[i], vin);
  }

  /* Fetch-based registration boxes */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function(input, init){
      var raw = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var info = requestInfo(raw);
      var promise = nativeFetch.apply(this, arguments);
      if (info) {
        promise.then(function(resp){
          try {
            resp.clone().text().then(function(text){
              var payload = parseAny(text);
              if (payload) remember(info.reg, payload);
            }).catch(function(){});
          } catch(e){}
        }).catch(function(){});
      }
      return promise;
    };
  }

  /* jQuery / XMLHttpRequest registration boxes */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__srVinV5Info = requestInfo(url);
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      if (this.__srVinV5Info) {
        var xhr = this;
        xhr.addEventListener('load', function(){
          try {
            var payload = xhr.responseType === 'json' ? xhr.response : parseAny(xhr.responseText);
            if (payload) remember(xhr.__srVinV5Info.reg, payload);
          } catch(e){}
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"], form.srp-product-form, form.srpa-product-form')) return;
    var vin = storedVin();
    if (vin) inject(form, vin);
  }, true);

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"] [type="submit"], form.srp-product-form [type="submit"], form.srpa-product-form [type="submit"]') : null;
    if (!btn || !btn.form) return;
    var vin = storedVin();
    if (vin) inject(btn.form, vin);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate, {once:true});
  else hydrate();

  if (window.MutationObserver && document.documentElement) {
    var observer = new MutationObserver(function(){ hydrate(); });
    observer.observe(document.documentElement, {childList:true, subtree:true});
  }
})();
